export default __webpack_public_path__ + "static/media/photo--lg--kickoff5.db29122b.jpg";